const uiVariable = {
  color: {
    secondary: '#7C7C7C',
    background1: '#413f56',
    background2: '#3c3956',
    background3: '#F9FAFF',
    backgroundGrey: '#91929E',
    backgroundGrey2: '#F5F5F5',
    header: '#413f56',
    link: '#92BD7E',
    error: '#d64b58',
    error2: '#ffa69e',
    button1: '#e0696c',
    button2: '#dc3545',
    button3: '#f47960',
    purple: '#7A81B9',
    purple2: '#C3C7EC',
    purple3: '#F2F3FC',
    text: '#2c3e50',
    textLight: '#f1f1f1',
    blue: '#99D2E3',
    yellow: '#F1C248',
    icon: '#7A81B9',
  },
  fontSize: {
    sm: '11px',
    md: '13px',
    lg: '16px',
    xl: '24px',
  },
}

export default uiVariable
